import './App.css';
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Search from './Component/Search/Search';
import OurCompany from './Component/Ourcompany/Ourcompany';
import ProjectDetails from './Component/ProjectDetails/ProjectDetails';
import Staff from './Component/Staff/Staff';
import ListedJobs from './Component/ListedJobs/ListedJobs';
import JobDetails from './Component/JobDetails/JobDetails';
import SalesCatalog from './Component/SalesCatalog/SalesCatalog';
import SecondStepSales from './Component/SecondStepSales/SecondStepSales';
import SalesDetails from './Component/SalesDetails/SalesDetails';
import News from './Component/News/News';
import NewsDetails from './Component/NewsDetails/NewsDetails';
import TermsPrivacy from './Component/TermsPrivacy/TermsPrivacy';




function App() {

  return (
    <div className="app-container">
      <BrowserRouter>
      <div className="main-content">
        <Routes>
      <Route path="/" element={<Search />} />
      <Route path="/ourcompany" element={<OurCompany />} />
      <Route path="/vilalproject/:projectId" element={<ProjectDetails />} />
      <Route path="/staff" element={<Staff />} />
      <Route path="/listedjobs" element={<ListedJobs />} />
      <Route path="/jobdetails/:jobId" element={<JobDetails />} />
      <Route path="/salescatalog" element={<SalesCatalog />} />
      <Route path="/secondstep/:buildingId" element={<SecondStepSales />} />
      <Route path="/salescatalogdetails/:buildingId/:categoryId" element={<SalesDetails />} />
      <Route path="/news" element={<News />} />
      <Route path="/newsdetails/:newsId" element={<NewsDetails />} />
      <Route path="/terms" element={<TermsPrivacy />} />
      </Routes>
      </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
